
<template>
<div class="loader align-center">

  <van-space direction="vertical" fill>

    <van-loading class="loader_simple" type="spinner" color="#01458c" size="22px" />

 
</van-space>


</div>

      
</template>

<script>

export default {
 
}
</script>
